<div class="input-pill-wrapper">
  <div class="input-pill-options-container">
    <label class="app-label" *ngIf="translationLabel || label"
      >{{ translationLabel || label | translation }}
    </label>
    <i
      style="padding-left: 5px"
      tooltipPosition="top"
      pTooltip="{{ tooltip }}"
      *ngIf="tooltip"
      class="fa-solid fa-circle-question text-link-color"></i>
    <div class="input-pill-input-container">
      <div class="input-pill-disabled-overlay" *ngIf="isDisabled"></div>
      <p-inputgroup>
        <input
          (focus)="onFocus()"
          [formControl]="newInput"
          #internalInput
          [style.padding-right]="!avoidNewInput ? '75px' : '12px'"
          [style.height]="'40px'"
          pInputText
          fluid
          [placeholder]="placeholder"
          (keyup.enter)="addInput()" />
        <p-inputgroup-addon *ngIf="!avoidNewInput">
          <button
            class="input-pill-input-enter-btn"
            [disabled]="shouldDisable || isDisabled"
            pButton
            severity="primary"
            (click)="addInput()">
            {{ 'enter' | translation }}
          </button>
        </p-inputgroup-addon>
      </p-inputgroup>
      <div
        *ngIf="filteredOptions.length"
        class="input-pill-autocomplete-suggestions">
        <div
          tooltipPosition="right"
          [escape]="false"
          [pTooltip]="option?.tooltip | truncate: 400|sanitizeHtmlTooltip"
          class="input-pill-autocomplete-suggestion"
          *ngFor="let option of filteredOptions"
          (click)="selectOption(option)"
          tabindex="0"
          (keydown.enter)="selectOption(option)">
          {{ option.text }}
        </div>
      </div>
    </div>

    <div class="input-pill-input">
      <div
        *ngFor="let control of control?.value||[]; let i = index"
        style="display: inline-block; margin-right: 5px">
        <p-chip
          label="{{ control?.text || control?.value || control || '' }}"
          [removable]="!isDisabled"
          (onRemove)="removeElement(control)"></p-chip>
      </div>
    </div>
  </div>
</div>
